export function computeAlphaCoverage(data, alphaThreshold = 16, sampleStep = 1) {
  if (!data || data.length === 0) return 0;
  const step = Math.max(1, sampleStep);
  let filled = 0;
  let total = 0;

  for (let i = 3; i < data.length; i += 4 * step) {
    total += 1;
    if (data[i] >= alphaThreshold) filled += 1;
  }

  if (total === 0) return 0;
  return filled / total;
}
